import { useMutation } from '@tanstack/react-query'

import { DefaultApiLoginTwoFactorAuthAppPostRequest } from '@src/api/generated/iam'
import { loginTwoFactorAuthAppPost } from '@src/api/repositories'
import { useAxios } from '@src/hooks/use-axios'

export const useLoginTwoFactorAuthApp = () => {
  const { axiosInstance } = useAxios({ apiType: 'IAM', shouldSkipLogout: true })

  return useMutation({
    mutationFn: (params: DefaultApiLoginTwoFactorAuthAppPostRequest) =>
      loginTwoFactorAuthAppPost(axiosInstance, params),
  })
}
